import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getDayFabricPositionOptions } from '../../../helpers/dayFabricPosition';
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../types';
import { Caption } from '../../Common/Caption';
import { Heading } from '../../Common/Heading';
import {
  Selector,
  SelectorImageItem,
  SelectorItem,
} from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
  dayFabricPosition: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (dayFabricPosition, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      dayFabricPosition,
    },
  });
};

export const DayFabricPosition = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { dayFabricPosition },
  } = state.context;
  const dayFabricPositionOptions = getDayFabricPositionOptions(state.context);
  const productType = getBaseProductType(state.context);
  if (
    isCurrentState('dayFabricPosition', state) &&
    dayFabricPositionOptions.length === 0
  ) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Day fabric position</Heading>
      <Selector isSlider={true}>
        {dayFabricPositionOptions.map(option => {
          const { showIcon, Icon, description } = getProductStateConfig(
            productType,
            'dayFabricPosition',
            option,
          );

          return (
            <SelectorImageItem
              isSelected={option === dayFabricPosition}
              onClick={onClick(option, send)}
              key={option}
              showIcon={showIcon}
              Icon={Icon}
              title={option}
              description={description}
            ></SelectorImageItem>
          );
        })}
      </Selector>
    </SectionContent>
  );
};
